import { render, staticRenderFns } from "./AppLanguage.vue?vue&type=template&id=afef0b94&"
import script from "./AppLanguage.vue?vue&type=script&lang=js&"
export * from "./AppLanguage.vue?vue&type=script&lang=js&"
import style0 from "./AppLanguage.vue?vue&type=style&index=0&id=afef0b94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports